import React from 'react';
import styled from 'styled-components';
import { bottomWithSafeArea } from '../../../shared/constants/safeArea';
import { getPageMessage } from '../../../shared/constants/pageMessages';
import { paperTextureSmall } from '../../../shared/component/paperTexture';
import { VenueIndexView } from '../../../shared/enum/EnumRepository';
import { useExhibitionVenueActions } from '../../../shared/hooks/useApi/useExhibitionVenue';
import { useExhibitionVenueStore } from '../../../shared/store/exhibitionVenueStore';
import { useLanguageStore } from '../../../shared/store/languageStore';

const ExhibitionViewToggleMobile: React.FC = () => {
  useLanguageStore((state) => state.language);
  const view = useExhibitionVenueStore((state) => state.view);
  const { setView } = useExhibitionVenueActions();
  const isAllVenues = view === VenueIndexView.ALL_VENUES;
  const nextView = isAllVenues
    ? VenueIndexView.CURRENT_EXHIBITIONS
    : VenueIndexView.ALL_VENUES;

  return (
    <Slot onClick={(e) => e.stopPropagation()}>
      <ToggleButton
        type="button"
        onClick={() => setView(nextView)}
      >
        {getPageMessage(
          isAllVenues
            ? 'EXHIBITION_VIEW_CURRENT_EXHIBITIONS_MOBILE'
            : 'EXHIBITION_VIEW_ALL_VENUES_MOBILE',
        )}
      </ToggleButton>
    </Slot>
  );
};

const Slot = styled.div`
  position: fixed;
  bottom: ${bottomWithSafeArea('clamp(30px, 7vw, 40px)')};
  right: clamp(18px, 5vw, 24px);
  z-index: 4;
`;

const ToggleButton = styled.button`
  position: relative;
  margin: 0;
  padding: 0 10px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  cursor: pointer;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Footer_01};
  ${paperTextureSmall}
  border: none;
  transition: transform 0.35s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    box-sizing: border-box;
    border: 0.5px solid ${({ theme }) => theme.colors.color_Gray_06};
    border-radius: inherit;
    pointer-events: none;
  }

  &:hover,
  &:focus-visible {
    transform: scale(0.92);
  }

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.color_Gray_03};
    outline-offset: 2px;
  }
`;

export default ExhibitionViewToggleMobile;
